import { jsx as _jsx } from "react/jsx-runtime";
import { StickAttribute } from "./StickAttribute";
import styles from "./StickAttributes.module.scss";
export const StickAttributes = ({ attributes }) => {
    if (!attributes.length) {
        return null;
    }
    return (_jsx("dl", { className: styles.attributes, "data-testid": "flavourAttributes", children: attributes
            .sort((a, b) => a.sortOrder - b.sortOrder)
            .map((attribute) => (_jsx(StickAttribute, { ...attribute }, attribute.id))) }));
};
//# sourceMappingURL=StickAttributes.js.map